import React from 'react'
import style from './Modal.module.css'
import { useState, useEffect } from 'react'
import { WarningButton, Button } from '../index'
import confirmedIcon from '../../assets/Modal/confirmed.svg'
import confirmIcon from '../../assets/Modal/confirm.svg'


const Modal = ({type, icon, text, title, showModal, onClick, cancelClick}) => {

    const [modalType, setType] = type;

    return (
        <div className={style.background_modal} data-disabled={showModal}>
            <div className={style.container} data-disabled={showModal}>
                {
                    type == 'changed'
                    ?
                    <img className={style.icon} src={confirmedIcon} alt="confirm icon" />
                    :
                    <img className={style.icon} src={confirmIcon} alt="confirm icon" />
                }
                <p className={style.title}>{title}</p>
                <p className={style.text}>{text}</p>
                {
                    type == 'changed' 
                    ?
                    <Button text='Cerrar' onClick={onClick}/>
                    :
                    <WarningButton text='Confirmar' onClick={onClick}/>
                }
                {
                    type == 'changed' 
                    ?
                    ''
                    :
                    <button className={style.cancel_button} onClick={cancelClick}>Cancelar</button>
                }
            </div>
        </div>
    )
}

export default Modal